// extracted by mini-css-extract-plugin
export default {"cardsContainer":"projectsProfile_cardsContainer__LwpN4","createButton":"projectsProfile_createButton__o5ALi"};